import type { StandaloneMenuItem } from './menu'

/** 活动总裁驾驶舱：新窗口纯净全屏（不带独立窗外壳） */
export const ACTIVITY_CEO_COCKPIT_VIEW_PATH = '/activity/cockpit-view'
export const ACTIVITY_CEO_COCKPIT_VIEW_NAME = 'ActivityCockpitView'

const ACTIVITY_CEO_COCKPIT_TITLES = ['总裁驾驶舱', '活动总裁驾驶舱']

function normalizePath(path: string) {
  return path.split('?')[0].replace(/\/+$/, '') || '/'
}

/** 侧栏是否命中活动总裁驾驶舱（按标题或 /activity/cockpit 路径） */
export function isActivityCeoCockpitMenu(item: Pick<StandaloneMenuItem, 'title' | 'path'>): boolean {
  if (ACTIVITY_CEO_COCKPIT_TITLES.includes(item.title)) {
    return true
  }
  const path = normalizePath(item.path).toLowerCase()
  return (
    path === '/activity/cockpit' ||
    path.endsWith('/activity/cockpit') ||
    path === '/ai-application-center/activity/cockpit' ||
    path.endsWith('/ai-application-center/activity/cockpit')
  )
}

/** 独立窗活动根路径（与当前地址栏前缀对齐） */
export function resolveActivityBasePath(currentPath: string): string {
  if (currentPath.startsWith('/ai-Application-center/')) {
    return '/ai-Application-center/activity'
  }
  return '/activity'
}

function treeHasActivityCeoCockpit(items: StandaloneMenuItem[]): boolean {
  return items.some((item) => {
    if (isActivityCeoCockpitMenu(item)) return true
    return Boolean(item.children?.length && treeHasActivityCeoCockpit(item.children))
  })
}

/**
 * 侧栏软注入「总裁驾驶舱」：插在概况后。
 * 正式菜单以 sql1007/activity-ceo-cockpit-menu 为准；未跑库 / 菜单缓存未刷新时靠此兜底。
 */
export function appendActivityCeoCockpitMenu(
  items: StandaloneMenuItem[],
  activityBase = '/activity'
): StandaloneMenuItem[] {
  if (treeHasActivityCeoCockpit(items)) {
    return items
  }
  const base = activityBase.replace(/\/+$/, '') || '/activity'
  const menu: StandaloneMenuItem = {
    key: 'activity-ceo-cockpit',
    title: '总裁驾驶舱',
    path: `${base}/cockpit`,
    icon: 'ep:monitor'
  }
  const next = [...items]
  const overviewIdx = items.findIndex((item) => {
    const p = normalizePath(item.path).toLowerCase()
    return p.includes('/activity/overview') || item.title === '概况'
  })
  const insertAt = overviewIdx >= 0 ? overviewIdx + 1 : 0
  next.splice(insertAt, 0, menu)
  return next
}
